// @flow

import React from 'react';
import { connect } from 'react-redux';
import Wysiwyg, { type ACFProps } from './wysiwyg';
import parseMacros from './helpers/parseMacros';
import { type Macro } from '../../helpers/macros';

const wysiwygWithMacros = (
  macros: Array<Macro> = [],
) => {
  type StateProps = {|
    parse: Function,
  |};
  const mapStateToProps = (state): StateProps => ({
    parse: parseMacros(part => (typeof part === 'function' ? part(state) : part)),
  });

  type Props = {|
    ...ACFProps,
    ...StateProps,
  |};
  const Component = ({ parse, replace_macros, ...props }: Props) => {
    if (replace_macros && macros.length > 0) {
      const { visiblePart, readMoreParts } = parse(props.content, macros);
      return (
        <Wysiwyg {...props} content={visiblePart} readMoreParts={readMoreParts} />
      );
    }
    return (
      <Wysiwyg {...props} />
    );
  };

  return connect<Props, ACFProps, any, any, any, any>(mapStateToProps)(Component);
};

export default wysiwygWithMacros;
